import { Injectable } from '@angular/core';
import { Subject } from "rxjs";

/** Готове до показу повідомлення про невдалий запит */
export interface HttpErrorNotice {
  /** Коротка причина */
  title: string;
  /** Що користувачу робити далі */
  text: string;
}

/**
 * Картка #252: до цього інтерцептор нічого не повідомляв користувачу -
 * у гілках обробки статусів стояли лише TODO. Сервіс віддає розібране
 * інтерцептором повідомлення глобальному блоку `app-http-error-message`.
 */
@Injectable({
  providedIn: 'root'
})
export class HttpErrorNotifyService {
  public noticeChange: Subject<HttpErrorNotice> = new Subject<HttpErrorNotice>();

  public show(title: string, text: string): void {
    this.noticeChange.next({ title, text });
  }
}
